// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ls-box[data-v-90e73d3a]{background-color:#fafafa;height:30px;display:flex;align-items:center;padding:0 10px;margin:-10px -10px 5px}", ""]);
// Exports
module.exports = exports;
